import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BarChart2, Package, Users, TrendingUp } from 'lucide-react';
import './SalesReportsPage.css';

export const SalesReportsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const reports: { id: string; title: string; description: string; icon: React.ReactNode; path: string }[] = [
    {
      id: 'summary',
      title: t('salesReports.summaryTitle'),
      description: t('salesReports.summaryDesc'),
      icon: <BarChart2 size={22} strokeWidth={1.75} />,
      path: '/reports/sales/summary'
    },
    {
      id: 'by-product',
      title: t('salesReports.byProductTitle'),
      description: t('salesReports.byProductDesc'),
      icon: <Package size={22} strokeWidth={1.75} />,
      path: '/reports/sales/by-product'
    },
    {
      id: 'by-customer',
      title: t('salesReports.byCustomerTitle'),
      description: t('salesReports.byCustomerDesc'),
      icon: <Users size={22} strokeWidth={1.75} />,
      path: '/reports/sales/by-customer'
    },
    {
      id: 'trends',
      title: t('salesReports.trendsTitle'),
      description: t('salesReports.trendsDesc'),
      icon: <TrendingUp size={22} strokeWidth={1.75} />,
      path: '/reports/sales/trends'
    }
  ];

  return (
    <div className="sales-reports-page">
      <div className="reports-header">
        <h1>{t('salesReports.title')}</h1>
        <p>{t('salesReports.subtitle')}</p>
      </div>

      <div className="reports-grid">
        {reports.map((report) => (
          <div key={report.id} className="report-card">
            <div className="report-icon">{report.icon}</div>
            <h3>{report.title}</h3>
            <p>{report.description}</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate(report.path)}
            >
              {t('common.view')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesReportsPage;
